import { useEffect, useState } from "react"
import Screen from "src/shared/components/layout/screen/Screen"
import "../index.css"
import './Configuracion.css'
import { InfoButton } from "../components/InfoButton/InfoButton"
import LargeCard from "src/shared/components/data-display/large-card/LargeCard"

import { formatCurrency } from "src/shared/hooks/formatCurrency"
import LargeCardSkeleton from "../../../shared/components/data-display/LargeCardSkeleton/LargeCardSkeleton"
import { useProfile } from "src/shared/hooks/useProfile"
import useEscapeKey from "src/shared/hooks/useEscapeKey"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { toggleNuevaCategoriaGastoModalOpen } from "src/store/gastos/gastosSlice"
import useSnackbar from "src/shared/hooks/useSnackbar"
import { useCategorias_GastoQuery } from "src/gql/schema"
import { sum } from "src/shared/helpers/calculator"

// Se ha indicado que la categoría que se muestra abierta por defecto es la de propinas
// https://www.figma.com/design/90axH66Vp2lIHj3OAjRTDw/UI-MASTER-EASYROOM-1?node-id=24979-11044&m=dev
const DEFAULT_CATEGORY_OPENED = "Propinas"

const ConfiguracionGastos = () => {
    const { hotel_id } = useProfile()
    const navigate = useNavigate()
    const { showSnackbar } = useSnackbar()
    const { isNuevaCategoriaGastoModalOpen } = useSelector((state: RootState) => state.gastos)
    const dispatch = useDispatch()

    const { data, refetch, loading } = useCategorias_GastoQuery({
        variables: {
            hotel_id,
            subcat_eliminados: false
        }
    })

    const [mesajeOpen, setMensajeOpen] = useState(false)

    const totalPresupuesto = sum(data?.categorias_gasto.map(g => g.presupuesto) || [])
    const totalLimiteMensual = sum(data?.categorias_gasto.map(g => g.limite_mensual) || [])

    const handleRefreshData = () => {
        refetch({
            hotel_id,
            subcat_eliminados: false
        })
    }

    useEffect(() => {
        if (mesajeOpen) {
            setTimeout(() => {
                setMensajeOpen(false)
            }, 5000)
        }
    }, [mesajeOpen])

    useEscapeKey({
        onEscape: () => {
            if (isNuevaCategoriaGastoModalOpen) {
                return dispatch(toggleNuevaCategoriaGastoModalOpen(false))
            }
            navigate(-1)
        },
    })

    return (
        <Screen title="Configuración de categorías" contentClassName="config-gastos-screen" close>
            <div className="configuracion_gastos__total__wrapper">
                <div className="config-gastos-subtitle-container">
                    <p className="config-gastos-subtitle">Límite total de gasto mensual:</p>
                    <p className="config-gastos-subtitle-total">{formatCurrency(totalLimiteMensual)}</p>
                    <InfoButton title={"¿Qué es?"} description={"Es la suma total de los límites de gasto mensuales establecidos en todas las categorías."} />
                </div>
                <div className="config-gastos-subtitle-container">
                    <p className="config-gastos-subtitle">Presupuesto total disponible:</p>
                    <p className="config-gastos-subtitle-total">{formatCurrency(totalPresupuesto)}</p>
                    <InfoButton title={"¿Qué es?"} description={"Es el presupuesto disponible, calculado como el límite total menos los gastos ya registrados."} />
                </div>
            </div>
            <div className="config-gastos-cards">
                {data &&
                    data.categorias_gasto.map((dataInfo, index) => (
                        <LargeCard
                            key={index}
                            title={dataInfo.categoria}
                            subtitle={""}
                            gastos={0}
                            limiteMensual={String(dataInfo?.limite_mensual === 0 ? "" : dataInfo?.limite_mensual)}
                            presupuesto={dataInfo.presupuesto}
                            id={dataInfo.categoria_id}
                            subCategorias={dataInfo.subcategorias_de_categoria}
                            onConfirmEdit={(success) => {
                                handleRefreshData()
                                if (success) {
                                    return showSnackbar({
                                        status: "success",
                                        text: `La categoría **${dataInfo.categoria}** ha sido modificada exitosamente`,
                                        title: `Cambios en categoría de ${dataInfo.categoria}`
                                    })
                                }
                                showSnackbar({
                                    status: "error",
                                    title: `Error al guardar los cambios`
                                })
                            }}
                            startOpened={dataInfo.categoria === DEFAULT_CATEGORY_OPENED}
                        />
                    ))}
                {loading && <LargeCardSkeleton />}
            </div>
            {/* <AddButton
                onAdd={() => {
                    dispatch(toggleNuevaCategoriaGastoModalOpen(true))
                }}
            /> */}

            {/* <AddModal
                isOpen={isNuevaCategoriaGastoModalOpen}
                onClose={() => dispatch(toggleNuevaCategoriaGastoModalOpen(false))}
                onSub={(value) => }
            /> */}
        </Screen>
    )
}

export { ConfiguracionGastos }
